import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";

const LINKS = [
  { hash: "#manifesto", id: "Manifesto", en: "Manifesto" },
  { hash: "#komoditas", id: "Komoditas", en: "Commodities" },
  { hash: "#ekosistem", id: "Ekosistem", en: "Ecosystem" },
  { hash: "#kontak", id: "Kontak", en: "Contact" },
];

export const Nav = () => {
  const { lang, setLang } = useApp();
  const [open, setOpen] = useState(false);

  const go = (hash) => {
    setOpen(false);
    if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -70 });
    else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#1E3A2B]/10">
      <div className="flex items-center justify-between px-4 sm:px-8 lg:px-16 h-[70px]">
        <button
          data-testid="nav-logo"
          onClick={() => go("#beranda")}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/logo-mark.png"
            alt="Yutaka Agro"
            data-testid="nav-logo-image"
            className="h-11 w-auto transition-transform duration-500 group-hover:scale-105"
          />
          <span className="leading-none text-left">
            <span className="block font-sans font-extrabold tracking-[0.18em] text-[#1E3A2B] text-xs sm:text-sm whitespace-nowrap">YUTAKA AGRO</span>
            <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-[#D96B27] mt-1">Growing Together</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              onClick={() => go(l.hash)}
              className="text-xs font-mono uppercase tracking-[0.18em] text-[#1E3A2B]/70 hover:text-[#D96B27] transition-colors duration-300"
            >
              {lang === "id" ? l.id : l.en}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center rounded-full border border-[#1E3A2B]/20 overflow-hidden" data-testid="language-toggle">
            {["id", "en"].map((l) => (
              <button
                key={l}
                data-testid={`language-toggle-${l}`}
                onClick={() => setLang(l)}
                className={`px-3 py-1.5 text-[11px] font-mono font-semibold uppercase tracking-widest transition-colors duration-300 ${
                  lang === l ? "bg-[#1E3A2B] text-[#FAF7F2]" : "text-[#1E3A2B]/60 hover:text-[#1E3A2B]"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-contact-button"
            onClick={() => go("#kontak")}
            className="hidden sm:block px-5 py-2.5 rounded-full bg-[#D96B27] text-[#FAF7F2] text-xs font-semibold tracking-wide hover:bg-[#1E3A2B] transition-colors duration-300"
          >
            {lang === "id" ? "Hubungi Kami" : "Contact Us"}
          </button>
          <Link
            to="/admin"
            data-testid="admin-login-button"
            className="p-2 rounded-full text-[#1E3A2B]/50 hover:text-[#D96B27] hover:bg-[#1E3A2B]/5 transition-colors duration-300"
            title="Admin"
          >
            <Lock size={15} />
          </Link>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-[#1E3A2B]"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAF7F2] border-t border-[#1E3A2B]/10 px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`mobile-nav-link-${l.hash.slice(1)}`}
              onClick={() => go(l.hash)}
              className="text-left font-serif text-2xl text-[#1E3A2B] hover:text-[#D96B27] transition-colors"
            >
              {lang === "id" ? l.id : l.en}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
